export class DeliveryIndicator {
  delivery: number = 0;
  deliveryTotal: number = 0;
  devolution: number = 0;
  devolutionTotal: number = 0;
}
